(function (root) {
  'use strict';

  const sizes = [
    { id: 'mini', name: 'small', grams: 200, label: '200 g' },
    { id: 'one-pound', name: '1 lb', grams: 454, label: '454 g' },
    { id: 'one-half-pound', name: '1½ lb', grams: 680, label: '680 g' },
    { id: 'kilo', name: '1 kg', grams: 1000, label: '1,000 g' }
  ];

  function mainLimit(sizeId) {
    const size = sizes.find(function (s) {
      return s.id === sizeId;
    });

    if (!size) return 8;
    if (size.grams === 200) return 4;
    if (size.grams === 454) return 6;

    return 8;
  }

  function validate(draft, flavours) {
    const main = Array.isArray(draft.main) ? draft.main : [];
    const backups = Array.isArray(draft.backups) ? draft.backups : [];

    const known = new Set(
      flavours
        .filter(function (f) {
          return f.available !== false;
        })
        .map(function (f) {
          return f.id;
        })
    );

    const errors = [];

    if (!sizes.some(function (s) {
      return s.id === draft.size;
    })) {
      errors.push('choose a bag size.');
    }

    const max = mainLimit(draft.size);

    if (main.length < 1 || main.length > max) {
      errors.push('choose 1–' + max + ' gummy varieties.');
    }

    if (backups.length < 2 || backups.length > 3) {
      errors.push('choose 2–3 backup varieties.');
    }

    if (
      new Set(main).size !== main.length ||
      new Set(backups).size !== backups.length
    ) {
      errors.push('choose each gummy only once.');
    }

    if (main.some(function (id) {
      return backups.includes(id);
    })) {
      errors.push(
        'backups must be different from your main gummies.'
      );
    }

    if (
      main.concat(backups).some(function (id) {
        return !known.has(id);
      })
    ) {
      errors.push(
        'one of your gummies is no longer available. please update your choices.'
      );
    }

    return {
      valid: errors.length === 0,
      errors: errors
    };
  }

  function swedishCount(draft, flavours) {
    const main = Array.isArray(draft.main) ? draft.main : [];

    return main.filter(function (id) {
      return flavours.some(function (f) {
        return f.id === id && f.category === 'Swedish';
      });
    }).length;
  }

  function findPricedVariant(draft, config) {
    const count = swedishCount(draft, config.flavours);

    return (config.pricedVariants || []).find(function (variant) {
      return (
        variant.size === draft.size &&
        Number(variant.swedishCount) === count
      );
    });
  }

  function buildCartItem(draft, config, quantity) {
    if (quantity === undefined) {
      quantity = 1;
    }

    const result = validate(draft, config.flavours);

    if (!result.valid) {
      throw new Error(result.errors.join(' '));
    }

    if (
      !Number.isInteger(quantity) ||
      quantity < 1 ||
      quantity > 20
    ) {
      throw new Error('choose between 1 and 20 bags.');
    }

    const selected = findPricedVariant(draft, config);

    if (
      !selected ||
      !selected.variantId ||
      !selected.available
    ) {
      throw new Error(
        'this bag and swedish gummy combination is unavailable. please choose another.'
      );
    }

    function labels(ids) {
      return ids.map(function (id) {
        const flavour = config.flavours.find(function (f) {
          return f.id === id;
        });

        return flavour ? flavour.name : '';
      }).join(', ');
    }

    const size = sizes.find(function (s) {
      return s.id === draft.size;
    });

    const count = swedishCount(draft, config.flavours);

    return {
      id: selected.variantId,
      quantity: quantity,
      properties: {
        'bag size': size.name + ' · ' + size.label,
        'gummies': labels(draft.main),
        'backup gummies': labels(draft.backups),
        'swedish gummy varieties': String(count),
        'substitutions':
          'use the listed backups only if a main gummy is unavailable. contact me if backups are unavailable too.'
      }
    };
  }

  function buildCartItems(draft, config, quantity) {
    return [buildCartItem(draft, config, quantity)];
  }

  const api = {
    sizes: sizes,
    mainLimit: mainLimit,
    validate: validate,
    swedishCount: swedishCount,
    findPricedVariant: findPricedVariant,
    buildCartItem: buildCartItem,
    buildCartItems: buildCartItems
  };

  root.CandyMix = api;

})(window);